import { Form } from '@extend/antd/form';
import { FormComponentProps } from 'antd/lib/form';
import React from 'react';
import { useManageLogs } from '../contexts/manage-logs.context';
import { Button, Col, Row, Select } from 'antd';

type TSearchPrivacyLogs = FormComponentProps & {};

const SearchPrivacyLogs = Form.create<TSearchPrivacyLogs>()((props: TSearchPrivacyLogs) => {
  const { searchPlatformTermUser } = useManageLogs();
  const { handleOnChangeCriteria } = searchPlatformTermUser;
  const { form } = Form.useForm(props.form);

  const onSearch = () => {
    form &&
      form.validateFields(async (error: any, values: any) => {
        if (error) return;
        handleOnChangeCriteria({ ...values, page: 0 });
      });
  };

  return (
    <Form layout="horizontal">
      <Row gutter={[10, 10]} type="flex" align="bottom">
        <Col xs={8}>
          <Form.Item label="User Ids">
            {form?.getFieldDecorator(
              'userIds',
              {}
            )(
              <Select
                mode="tags"
                placeholder={'Enter(s) User Id'}
                maxTagCount={1}
                maxTagTextLength={6}
                allowClear
                showArrow
                showSearch
              ></Select>
            )}
          </Form.Item>
        </Col>

        <Col>
          <Button loading={searchPlatformTermUser?.isLoading} type="primary" icon="search" onClick={onSearch}>
            Search
          </Button>
        </Col>
      </Row>
    </Form>
  );
});

export default SearchPrivacyLogs;
